import { IModelBase } from 'common-components'
import { Injectable } from '@angular/core'
import { SmODataConfiguration } from '@exchange/services/core/odata'
import { HttpClient } from '@angular/common/http'
import { ODataService } from 'common-services'

export enum LocationCoverageTypes {
  ZipCode = 1,
  Distance
}

export interface ILocationCoverageType extends IModelBase {
  Name: string
}

@Injectable()
export class LocationCoverageTypeODataService extends ODataService<ILocationCoverageType> {
  constructor(
    protected http: HttpClient,
    protected config: SmODataConfiguration
  ) {
    super(http, config)
    this.typeName = 'LocationCoverageTypes'
  }
}
